import { submitModalState, paginationParam } from 'shared/constant';

import {
  GET_LIST_COMPANY,
  GET_LIST_COMPANY_SUCCESS,
  GET_LIST_COMPANY_FAILED,
  GET_SINGLE_COMPANY,
  GET_SINGLE_COMPANY_SUCCESS,
  GET_SINGLE_COMPANY_FAILED,
  GET_SINGLE_EMPLOYEE,
  UPDATE_SINGLE_EMPLOYEE_PAYLOAD,
  GET_LIST_EMPLOYEE,
  GET_LIST_EMPLOYEE_SUCCESS,
  GET_LIST_EMPLOYEE_FAILED,
  GET_ALL_MODULES,
  GET_ALL_MODULES_SUCCESS,
  GET_ALL_MODULES_FAILED,
  SET_STATUS_EMPLOYEE,
  SET_STATUS_EMPLOYEE_SUCCESS,
  SET_STATUS_EMPLOYEE_FAILED,
  SET_SINGLE_COMPANY,
  SET_SINGLE_EMPLOYEE,
  SET_COMPANY_PIC,
  GET_AVAILABLE_MODULES_INIT,
  GET_AVAILABLE_MODULES_SUCCESS,
  GET_AVAILABLE_MODULES_ERROR,
  UPDATE_EMPLOYEE_ROLES,
  UPDATE_AVAILABLE_MODULES,
  INIT_SUBMIT_NEW_COMPANY,
  UPDATE_SUBMIT_MODAL_OPEN,
  UPDATE_CREATE_NEW_COMPANY_PARAMS,
  UPDATE_CREATE_NEW_COMPANY_STEP,
  CREATE_ORGANIZATION_SUCCESS,
  CREATE_ORGANIZATION_ERROR,
  CREATE_USER_SUCCESS,
  CREATE_USER_ERROR,
  CREATE_EMPLOYEE_SUCCESS,
  CREATE_EMPLOYEE_ERROR,
  UPDATE_SUBMIT_MODAL_FINISH_OPEN,
  RETRY_ORGANIZATION,
  RETRY_USER,
  RETRY_EMPLOYEE,
  RESET_AVAILABLE_MODULES,
  RESET_SUBMIT_MODAL,
  INIT_SUBMIT_NEW_EMPLOYEE,
  GET_LIST_ROLES_EMPLOYEE,
  GET_LIST_ROLES_EMPLOYEE_SUCCESS,
  GET_LIST_ROLES_EMPLOYEE_FAILED,
  ACTIVATE_EMPLOYEE_ROLE_SUCCESS,
  DEACTIVATE_EMPLOYEE_ROLE_SUCCESS,
  GET_SINGLE_ROLE_EMPLOYEE,
  UPDATE_SINGLE_ROLE_EMPLOYEE_PAYLOAD,
  SHOW_ROLLBACK_MODAL,
  CANCEL_ROLLBACK_MODAL,
  ROLLBACK_USER,
  ROLLBACK_ORGANIZATION,
  ROLLBACK_ERROR,
  ROLLBACK_SUCCESS,
  ROLLBACK_FINISH,
  INIT_SUBMIT_EDIT_EMPLOYEE,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR,
  UPDATE_EMPLOYEE_SUCCESS,
  UPDATE_EMPLOYEE_ERROR,
  UPDATE_SUBMIT_MODAL_ERROR_OPEN,
  UPDATE_INITIAL_USER_ROLES,
} from '../actions/types';

export const initialState = {
  companyList: [],
  companyFilter: paginationParam,
  getCompanyListLoading: false,
  companyDetail: {},
  employeeList: [],
  employeeFilter: paginationParam,
  allModules: [],
  getAllModulesLoading: false,
  getLoading: false,
  employeeId: null,
  companyPIC: {
    name: '',
    email: '',
    phoneNumber: '',
    nationalID: '',
    photo: {},
  },
  loadingAvailableModules: false,
  loadingAvailableModulesError: '',
  availableModules: [],
  employeeRoles: [],
  submitModalOpen: false,
  submitAddCompanyState: submitModalState.NOT_STARTED,
  submitAddUserState: submitModalState.NOT_STARTED,
  submitAddEmployeeState: submitModalState.NOT_STARTED,
  createNewCompanyParams: {},
  createNewCompanyStep: 1,
  submitModalFinishOpen: false,
  submitModalErrorOpen: false,
  employeeRoleList: {},
  loading: true,
  detailEmployee: {},
  error: '',
  employeeRolesAll: [],
  rollbackModalOpen: false,
  rollbackModalFinishOpen: false,
  isRollbackSuccess: false,
  initialUserRoles: [],
  loadingInitialUserRoles: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_LIST_COMPANY:
      return {
        ...state,
        getCompanyListLoading: true,
      };
    case GET_ALL_MODULES:
      return {
        ...state,
        getAllModulesLoading: true,
      };
    case GET_LIST_EMPLOYEE:
    case GET_SINGLE_COMPANY:
      return {
        ...state,
        getLoading: true,
      };
    case GET_LIST_ROLES_EMPLOYEE:
      return {
        ...state,
        getLoading: true,
        employeeRolesAll: [],
      };
    case GET_SINGLE_COMPANY_SUCCESS:
    case GET_LIST_EMPLOYEE_FAILED:
    case GET_SINGLE_COMPANY_FAILED:
      return {
        ...state,
        ...action.payload,
        getLoading: false,
      };
    case GET_LIST_COMPANY_FAILED:
      return {
        ...state,
        companyList: [],
        getCompanyListLoading: false,
      };
    case GET_LIST_COMPANY_SUCCESS:
      return {
        ...state,
        companyList: action.companyList,
        companyFilter: action.pagination,
        getCompanyListLoading: false,
      };
    case GET_ALL_MODULES_SUCCESS:
      return {
        ...state,
        allModules: action.allModules,
        getAllModulesLoading: false,
      };
    case GET_ALL_MODULES_FAILED:
      return {
        ...state,
        allModules: [],
        getAllmodulesLoading: false,
      };
    case GET_LIST_EMPLOYEE_SUCCESS:
      return {
        ...state,
        employeeList: action.employeeList,
        employeeFilter: action.pagination,
        getLoading: false,
      };
    case SET_STATUS_EMPLOYEE:
      return {
        ...state,
        employeeId: action.payload,
      };
    case SET_STATUS_EMPLOYEE_SUCCESS:
    case SET_STATUS_EMPLOYEE_FAILED:
      return {
        ...state,
        employeeId: null,
      };
    case SET_SINGLE_COMPANY:
      return {
        ...state,
        detailCompany: action.payload,
      };
    case SET_SINGLE_EMPLOYEE:
      return {
        ...state,
        detailEmployee: action.payload,
      };
    case SET_COMPANY_PIC:
      return {
        ...state,
        companyPIC: action.payload,
      };
    case GET_AVAILABLE_MODULES_INIT: {
      return {
        ...state,
        loadingAvailableModules: true,
      };
    }
    case GET_AVAILABLE_MODULES_SUCCESS: {
      return {
        ...state,
        availableModules: action.payload,
        initialAvailableModules: action.payload,
        loadingAvailableModules: false,
      };
    }
    case RESET_AVAILABLE_MODULES: {
      return {
        ...state,
        availableModules: [...state.initialAvailableModules],
        employeeRoles: [...state.initialEmployeeRoles],
      };
    }
    case GET_AVAILABLE_MODULES_ERROR: {
      return {
        ...state,
        loadingAvailableModulesError: action.error,
        loadingAvailableModules: false,
      };
    }
    case UPDATE_AVAILABLE_MODULES: {
      return {
        ...state,
        availableModules: action.availableModules,
      };
    }
    case UPDATE_EMPLOYEE_ROLES: {
      return {
        ...state,
        employeeRoles: action.employeeRoles,
      };
    }
    case INIT_SUBMIT_NEW_COMPANY: {
      return {
        ...state,
        submitAddCompanyState: submitModalState.INITIALIZED,
        submitAddUserState: submitModalState.NOT_STARTED,
        submitAddEmployeeState: submitModalState.NOT_STARTED,
        submitModalFinishOpen: false,
        submitModalErrorOpen: false,
        createNewCompanyParams: action.params,
        createNewCompanyStep: 3,
      };
    }
    case UPDATE_SUBMIT_MODAL_OPEN: {
      return {
        ...state,
        submitModalOpen: action.value,
      };
    }
    case UPDATE_CREATE_NEW_COMPANY_PARAMS: {
      return {
        ...state,
        createNewCompanyParams: action.params,
      };
    }
    case UPDATE_CREATE_NEW_COMPANY_STEP: {
      return {
        ...state,
        createNewCompanyStep: action.step,
      };
    }
    case CREATE_ORGANIZATION_SUCCESS: {
      return {
        ...state,
        createNewCompanyParams: action.params,
        submitAddCompanyState: submitModalState.SUCCESS,
        submitAddUserState: submitModalState.INITIALIZED,
      };
    }
    case CREATE_ORGANIZATION_ERROR: {
      return {
        ...state,
        submitAddCompanyState: submitModalState.FAILED,
      };
    }
    case CREATE_USER_SUCCESS: {
      return {
        ...state,
        createNewCompanyParams: action.params,
        submitAddUserState: submitModalState.SUCCESS,
        submitAddEmployeeState: submitModalState.INITIALIZED,
      };
    }
    case CREATE_USER_ERROR: {
      return {
        ...state,
        submitAddUserState: submitModalState.FAILED,
      };
    }
    case CREATE_EMPLOYEE_SUCCESS: {
      return {
        ...state,
        createNewCompanyParams: action.params,
        submitAddEmployeeState: submitModalState.SUCCESS,
        // submitModalOpen: false,
        // submitModalFinishOpen: true,
      };
    }
    case CREATE_EMPLOYEE_ERROR: {
      return {
        ...state,
        submitAddEmployeeState: submitModalState.FAILED,
      };
    }
    case RETRY_ORGANIZATION: {
      return {
        ...state,
        submitAddCompanyState: submitModalState.INITIALIZED,
      };
    }
    case RETRY_USER: {
      return {
        ...state,
        submitAddUserState: submitModalState.INITIALIZED,
      };
    }
    case RETRY_EMPLOYEE: {
      return {
        ...state,
        submitAddEmployeeState: submitModalState.INITIALIZED,
      };
    }
    case UPDATE_SUBMIT_MODAL_FINISH_OPEN: {
      return {
        ...state,
        submitModalFinishOpen: action.value,
      };
    }
    case RESET_SUBMIT_MODAL: {
      return {
        ...state,
        submitModalOpen: false,
        submitAddCompanyState: submitModalState.NOT_STARTED,
        submitAddUserState: submitModalState.NOT_STARTED,
        submitAddEmployeeState: submitModalState.NOT_STARTED,
        createNewCompanyParams: {},
        createNewEmployeeParams: {},
        submitModalFinishOpen: false,
        createNewCompanyStep: 1,
        availableModules: action.newModules || initialState.availableModules,
        employeeRolesAll: action.newRoles || initialState.employeeRolesAll,
        employeeRoles: action.newRoles || initialState.employeeRoles,
        initialUserRoles: action.newRoles || initialState.employeeRoles,
      };
    }
    case INIT_SUBMIT_NEW_EMPLOYEE: {
      return {
        ...state,
        submitModalOpen: true,
        submitAddUserState: submitModalState.INITIALIZED,
        submitAddEmployeeState: submitModalState.NOT_STARTED,
        submitModalFinishOpen: false,
        createNewCompanyStep: 3,
      };
    }
    case ACTIVATE_EMPLOYEE_ROLE_SUCCESS:
    case DEACTIVATE_EMPLOYEE_ROLE_SUCCESS:
      return {
        ...state,
      };
    case GET_SINGLE_EMPLOYEE:
      return {
        ...state,
        loading: true,
        detailEmployee: {},
        error: '',
      };
    case UPDATE_SINGLE_EMPLOYEE_PAYLOAD:
      return {
        ...state,
        detailEmployee: action.payload,
        error: action.error || '',
        loading: false,
      };
    case GET_SINGLE_ROLE_EMPLOYEE:
      return {
        ...state,
        loading: true,
        detailRoleEmployee: {},
        error: '',
      };
    case UPDATE_SINGLE_ROLE_EMPLOYEE_PAYLOAD:
      return {
        ...state,
        loading: false,
        detailRoleEmployee: action.payload,
        error: action.error || '',
      };
    case GET_LIST_ROLES_EMPLOYEE_SUCCESS:
      return {
        ...state,
        employeeRolesAll: action.employeeRolesAll,
        pagination: action.pagination || {},
        getLoading: false,
      };
    case GET_LIST_ROLES_EMPLOYEE_FAILED:
      return {
        ...state,
        employeeRolesAll: action.employeeRolesAll,
        pagination: {},
        getLoading: false,
      };
    case SHOW_ROLLBACK_MODAL:
      return {
        ...state,
        submitModalOpen: false,
        rollbackModalOpen: true,
      };
    case CANCEL_ROLLBACK_MODAL:
      return {
        ...state,
        rollbackModalOpen: false,
        submitModalOpen: true,
      };
    case ROLLBACK_USER:
      return {
        ...state,
        rollbackModalOpen: false,
        rollbackModalFinishOpen: false,
        submitModalOpen: true,
        submitAddUserState: submitModalState.ROLLBACK,
        submitAddEmployeeState: submitModalState.NOT_STARTED,
      };
    case ROLLBACK_ORGANIZATION:
      return {
        ...state,
        rollbackModalOpen: false,
        rollbackModalFinishOpen: false,
        submitModalOpen: true,
        submitAddCompanyState: submitModalState.ROLLBACK,
        submitAddUserState: submitModalState.NOT_STARTED,
      };
    case ROLLBACK_ERROR:
      return {
        ...state,
        isRollbackSuccess: false,
        submitModalOpen: false,
        rollbackModalFinishOpen: true,
      };
    case ROLLBACK_SUCCESS:
      return {
        ...state,
        isRollbackSuccess: true,
        submitModalOpen: false,
        rollbackModalFinishOpen: true,
      };
    case ROLLBACK_FINISH:
      return {
        ...state,
        rollbackModalFinishOpen: false,
        createNewCompanyStep: 2,
      };
    case INIT_SUBMIT_EDIT_EMPLOYEE:
      return {
        ...state,
        submitModalOpen: true,
        submitAddUserState: submitModalState.INITIALIZED,
        submitAddEmployeeState: submitModalState.NOT_STARTED,
        submitModalFinishOpen: false,
        createNewCompanyParams: action.params,
        createNewCompanyStep: 3,
      };
    case UPDATE_USER_SUCCESS: {
      return {
        ...state,
        updateCompanyParams: action.params,
        submitAddUserState: submitModalState.SUCCESS,
        submitAddEmployeeState: submitModalState.INITIALIZED,
      };
    }
    case UPDATE_USER_ERROR: {
      return {
        ...state,
        submitAddUserState: submitModalState.FAILED,
      };
    }
    case UPDATE_EMPLOYEE_SUCCESS: {
      return {
        ...state,
        updateCompanyParams: action.params,
        submitAddEmployeeState: submitModalState.SUCCESS,
        submitModalOpen: false,
        // submitModalFinishOpen: true,
      };
    }
    case UPDATE_EMPLOYEE_ERROR: {
      return {
        ...state,
        submitAddEmployeeState: submitModalState.FAILED,
      };
    }
    case UPDATE_SUBMIT_MODAL_ERROR_OPEN:
      return {
        ...state,
        submitModalErrorOpen: action.value,
        rollbackModalOpen: false,
      };
    case UPDATE_INITIAL_USER_ROLES:
      return {
        ...state,
        loadingInitialUserRoles: action.loadingInitialUserRoles,
        initialUserRoles: action.initialUserRoles,
      };
    default:
      return state;
  }
}
